<template>
  <div class="iframe-container">
    <iframe
      v-if="settings.licence_id"
      :src="`${iframeUrl}?accountKey=${settings.licence_id}`"
      width="100%"
      frameborder="0"
      class="analytics-iframe"
      id="analytics-iframe"
    ></iframe>
  </div>
</template>

<script>
import insights from "@/utils/analytics/insights";

// import transferredPercentage from './transferredPercentage'
// import channelPercentagePie from './channelPercentagePie'
import fixedRanges from "@/components/common/DateRange/fixedRanges";
import common from "../../utils/common";
import env from "../../utils/env";
export default {
  name: "SingleAccountIndex",
  components: {},
  data() {
    return {
      fixedRanges,
      accountData: {},
      accountLoader: false,
      isMounted: false,
      dateRangeModel: {
        range: "thisYear",
        date: {
          startDate: this.$moment(this.$moment().add(-1, "Y")).format(
            "YYYY/MM/DD"
          ),
          endDate: this.$moment().format("YYYY/MM/DD"),
        },
      },
      dateRange: {
        range: "thisYear",
        date: {
          startDate: this.$moment(this.$moment().add(-1, "Y")).format(
            "YYYY/MM/DD"
          ),
          endDate: this.$moment().format("YYYY/MM/DD"),
        },
      },
      filterDrawer: false,
      status: "off",
      settings: {},
    };
  },
  computed: {
    iframeUrl() {
      return env.ANALYTICS_IFRAME_URL;
    },
    dateRangeMenuLabel() {
      let result = "";
      const filtered = this.fixedRanges.filter(
        (r) => r.value === this.dateRangeModel.range
      );
      if (filtered && filtered.length) result = filtered[0].label;
      return result;
    },
    dataRangeState() {
      return {
        from: this.dateRangeModel.date
          ? this.dateRangeModel.date.startDate
          : null,
        to: this.dateRangeModel.date ? this.dateRangeModel.date.endDate : null,
      };
    },
  },
  mounted() {
    this.getAccountData();
    this.getSettings();
    setTimeout(() => {
      this.isMounted = true;
    }, 1000);
    // Selecting the iframe element

    // Adjusting the iframe height onload event
  },
  methods: {
    getSettings() {
      this.$store.dispatch("setLoader", true);
      this.$http_bot
        .get("/settings/")
        .then((response) => {
          this.settings = response.data;
          this.$store.dispatch("setLoader", false);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
          if (error.response.status === 401) {
            common.logOut();
            this.$store.dispatch("setLoader", false);
          }
        });
    },
    // async getAccountStatus(id) {
    //   let data = await healthCheck.getHealthByEnv(id);
    //   this.status = await data.data;
    //   this.accountData.envName = await this.status.environments[id].name;
    // },
    getAccountData() {
      this.accountLoader = true;
      let numbers = insights.getAccountData({
        params: {
          from: this.dateRangeModel.date
            ? this.$moment(this.dateRangeModel.date.startDate).format(
                "YYYY/MM/DD"
              )
            : null,
          to: this.dateRangeModel.date
            ? this.$moment(this.dateRangeModel.date.endDate).format(
                "YYYY/MM/DD"
              )
            : null,
        },
      });
      numbers
        .then((response) => {
          this.accountLoader = false;
          this.accountData = response;

          // standard
          // this.accountData = {"id":8,"current_sessions":37491,"sessions_limit":55500,"active":true,"account_manager":"Ahmed Kadry","deployment_model":"Cloud","name":"MedNet","partners":"IST","payment_model":"Sessions","sessions_remaining":18009,"usage_percentage":67.55135135135136,"average":110,"average_7_days":4,"average_30_days":3,"perdiction_will_end_in":164,"perdiction_will_end_in_7_days":4502,"perdiction_will_end_in_30_days":6003,"messages":284424,"last_day":2,"channels":[{"_id":"5f05af690c39b53409832088","name":"Web","slug":"web","message_limit":100000,"session_duration":43200,"urls":["https://consumption.botter.live/package?bot_id=8m4UcwyAOFfORIypaKbR&channel=web","https://consumption.botter.live/package?bot_id=08lho0hndpb7g50dqzbbq4j"],"current_sessions":56170,"usage_percentage":85.83828720754313},{"_id":"5f05af690c39b5340983208a","name":"WhatsApp","slug":"whatsapp","message_limit":100000,"session_duration":43200,"url":"https://consumption.botter.live/package?bot_id=p2r5lojls3k1v5on1ra48&channel=whatsapp","current_sessions":8280,"usage_percentage":12.65339181197182},{"_id":"5f05af690c39b534098320891","name":"Facebook","slug":"facebook","message_limit":100000,"session_duration":43200,"url":"https://consumption.botter.live/package?bot_id=8m4UcwyAOFfORIypaKbR&channel=facebook","current_sessions":987,"usage_percentage":1.5083209804850466}]}

          //actual
          // this.accountData = {"autoDeactivate":false,"current_sessions":162,"channels":[{"_id":"5f05af690c39b53409832088","name":"Web","slug":"web","message_limit":100,"session_duration":1440,"updated_at":"2020-07-08T11:35:05.253Z","created_at":"2020-07-08T11:35:05.253Z","current_sessions":69006,"usage_percentage":80.27967472108148},{"_id":"5f05af690c39b53409832089","name":"Facebook","slug":"facebook","message_limit":100,"session_duration":1440,"updated_at":"2020-07-08T11:35:05.254Z","created_at":"2020-07-08T11:35:05.254Z","current_sessions":45,"usage_percentage":0.05235175727398583},{"_id":"5f05af690c39b5340983208a","name":"WhatsApp","slug":"whatsapp","message_limit":100,"session_duration":1440,"updated_at":"2020-07-08T11:35:05.254Z","created_at":"2020-07-08T11:35:05.254Z","current_sessions":509,"usage_percentage":0.5921565433879731},{"_id":"5f1564d566e10d3d1cd0d8d7","name":"IOS","slug":"mobile-ios","message_limit":100,"session_duration":1440,"updated_at":"2021-04-11T11:57:28.029Z","created_at":"2021-04-11T11:57:28.029Z","current_sessions":11422,"usage_percentage":13.28803936852147},{"_id":"5f1564e466e10d3d1cd0d8d8","name":"Android","slug":"mobile-android","message_limit":100,"session_duration":1440,"updated_at":"2021-04-11T11:57:28.029Z","created_at":"2021-04-11T11:57:28.029Z","current_sessions":4975,"usage_percentage":5.7877776097351}],"_id":"5ff474199d66382ce544b659","sessions_limit":10000000,"active":true,"updated_at":"2020-08-18T11:26:41.756Z","created_at":"2020-12-29T13:00:48.546Z","usage_percentage":0.00162,"transferred_to_agent":0,"transferred_to_agent_percentage":0,"agentJoined":0,"agentNotJoined":0,"agentLeft":0,"userLeft":0}
        })
        .catch(() => {
          this.accountLoader = false;
        });
    },
    toggleFilterDrawer(status) {
      this.filterDrawer = status;
      // this.dateRange.date = val.date.map((d) => (d._i ? d._i : d))
    },
    handleFilterByDateMenuClick({ key }) {
      this.dateRange.range = key;
      if (key === "custom") this.toggleFilterDrawer(true);
    },
    handleMenuItemClick({ key }) {
      // console.log('re')
      this.dateRangeModel.range = key;
      if (key && key !== "custom") this.getAccountData();
      else if (key && key === "custom") {
        this.toggleFilterDrawer(true);
      }
    },
  },
  watch: {
    // dataRangeState() {
    //   this.getAccountData()
    // },
    // dateRangeModel: {
    //   deep: true,
    //   handler(val) {
    //     this.dateRange.date = {
    //       startDate: this.$moment(val.date.startDate).format('YYYY/MM/DD'),
    //       endDate: this.$moment(val.date.endDate).format('YYYY/MM/DD')
    //     }
    //   }
    // }
  },
};
</script>
<style src="@/assets/css/bs-helpers.css" lang="css" scoped />
<style>
.second-header {
  /* border-bottom: 1px solid #e4e9f0; */
  /* padding: 0.5rem 1.86rem */
  margin-top: -2rem;
  padding-top: 0.4rem;
}
.second-header-divider {
  margin-top: 0 !important;
  padding-top: 0 !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  position: absolute !important;
  width: 100vw !important;
  left: 0;
  z-index: 2;
  top: 93px !important;
}
.container {
  padding-top: 2rem;
}
.y-house-keeper {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.fade-in {
  animation: fadeIn ease 2s;
  -webkit-animation: fadeIn ease 2s;
  -moz-animation: fadeIn ease 2;
  -o-animation: fadeIn ease 2s;
  -ms-animation: fadeIn ease 2s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (min-width: 1500px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 1250px;
  }
}
.iframe-container {
  height: 100vh;
  margin-top: -70px;
  overflow-y: hidden;
}
.iframe-container .analytics-iframe {
  border: 0;
  height: 100%;
  left: 0;
  width: 100%;
}
</style>
